module.exports = __webpack_public_path__ + "img/s4s76851.efc87f52.jpeg";